import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "account-value-row" };
const _hoisted_2 = {
    key: 0,
    class: "selected-stack"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 0,
    class: "selected-stack-avatar selected-stack-counter stack-overlap"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "account-value" };
const _hoisted_7 = { class: "account-list" };
const _hoisted_8 = { class: "row-right" };
const _hoisted_9 = { class: "row-balance" };
const _hoisted_10 = ["src"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = { class: "account-row-label" };
const _hoisted_13 = { class: "row-right" };
const _hoisted_14 = { class: "row-balance" };
const _hoisted_15 = {
    key: 0,
    class: "sub-accounts-wrapper"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "sub-account-info" };
const _hoisted_18 = { class: "avatar-stack" };
const _hoisted_19 = ["src"];
const _hoisted_20 = {
    key: 0,
    class: "stack-avatar stack-counter stack-overlap"
};
const _hoisted_21 = { class: "sub-name" };
const _hoisted_22 = { class: "row-right" };
const _hoisted_23 = { class: "row-balance" };
const _hoisted_24 = ["src"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = { class: "sub-account-info" };
const _hoisted_27 = ["src"];
const _hoisted_28 = { class: "sub-details" };
const _hoisted_29 = { class: "sub-name" };
const _hoisted_30 = { class: "sub-meta" };
const _hoisted_31 = { key: 0 };
const _hoisted_32 = { class: "row-right" };
const _hoisted_33 = { class: "row-balance" };
const _hoisted_34 = ["src"];
import { ref, computed } from 'vue';
import { useAppState } from '@/composables/useAppState';
import SlideDrawer from './SlideDrawer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountSelector',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const state = useAppState();
        function formatBalance(amount) {
            if (localStorage.getItem('randomiseFigures') === 'true')
                return '£####';
            return state.formatter.format(amount);
        }
        function sumBalances(accounts) {
            return accounts.reduce((sum, a) => sum + (a.balance ?? 0), 0);
        }
        const allAccountsBalance = computed(() => sumBalances((state.bankInfo?.accounts || []).filter((a) => a.source === 0)));
        const props = __props;
        const emit = __emit;
        const drawerOpen = ref(false);
        const expandedKey = ref(null);
        function openDrawer() {
            // Auto-expand the group that contains the current selection
            expandedKey.value = null;
            for (const group of accountGroups.value) {
                if (props.modelValue === group.type) {
                    expandedKey.value = group.type;
                    break;
                }
                for (const account of group.accounts) {
                    if (account.id === props.modelValue) {
                        expandedKey.value = group.type;
                        break;
                    }
                }
                if (expandedKey.value)
                    break;
            }
            drawerOpen.value = true;
        }
        function cleanBrandName(name) {
            if (!name)
                return '';
            const map = { 'ø': 'o', 'Ø': 'O', 'æ': 'ae', 'Æ': 'AE', 'ß': 'ss', 'ð': 'd', 'Ð': 'D', 'þ': 'th', 'Þ': 'Th', 'đ': 'd', 'Đ': 'D', 'ł': 'l', 'Ł': 'L' };
            let ret = name.replace(/[ /]/g, '+');
            ret = ret.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\x20-\x7E]/g, function (c) { return map[c] || ''; });
            ret = encodeURIComponent(ret);
            return ret;
        }
        function getBrandLogoUrl(name) {
            if (!name)
                return require('@/assets/round3.png');
            return 'https://api.sysodev.link/BrandLogos/' + cleanBrandName(name);
        }
        function maskAccountNumber(num) {
            const s = String(num);
            if (s.length <= 4)
                return s;
            return '**** ' + s.slice(-4);
        }
        function getAvatarUrl(account) {
            return account.bank?.logoUri || getBrandLogoUrl(account.bank?.name);
        }
        const accountGroups = computed(() => {
            const accounts = (state.bankInfo?.accounts || []).filter((a) => a.source === 0);
            const groups = {
                current: { label: 'Current accounts', accounts: [] },
                credit: { label: 'Credit cards', accounts: [] },
                savings: { label: 'Savings accounts', accounts: [] },
            };
            for (const a of accounts) {
                const type = a.accountType?.prettyName;
                if (type === 'Current')
                    groups.current.accounts.push(a);
                else if (type === 'Credit')
                    groups.credit.accounts.push(a);
                else if (type === 'Savings')
                    groups.savings.accounts.push(a);
            }
            return Object.entries(groups)
                .filter(([, g]) => g.accounts.length > 0)
                .map(([type, g]) => ({
                type,
                label: g.label,
                accounts: g.accounts,
                avatarStack: g.accounts.slice(0, 3).map(a => getAvatarUrl(a)),
                overflowCount: Math.max(0, g.accounts.length - 3),
                balance: sumBalances(g.accounts),
            }));
        });
        const selectedAccount = computed(() => {
            if (props.modelValue === 'all' || !state.bankInfo?.accounts)
                return null;
            for (const group of accountGroups.value) {
                if (props.modelValue === group.type)
                    return null;
                for (const account of group.accounts) {
                    if (account.id === props.modelValue)
                        return account;
                }
            }
            return null;
        });
        const selectedAvatarUrl = computed(() => {
            if (!selectedAccount.value)
                return null;
            return getAvatarUrl(selectedAccount.value);
        });
        const selectedAvatarStack = computed(() => {
            if (props.modelValue === 'all') {
                const accounts = (state.bankInfo?.accounts || []).filter((a) => a.source === 0);
                if (!accounts.length)
                    return null;
                return {
                    urls: accounts.slice(0, 3).map((a) => getAvatarUrl(a)),
                    overflowCount: Math.max(0, accounts.length - 3),
                };
            }
            const group = accountGroups.value.find(g => g.type === props.modelValue);
            if (!group)
                return null;
            return { urls: group.avatarStack, overflowCount: group.overflowCount };
        });
        const selectedLabel = computed(() => {
            if (props.modelValue === 'all' || !state.bankInfo?.accounts)
                return 'All accounts';
            for (const group of accountGroups.value) {
                if (props.modelValue === group.type)
                    return 'All ' + group.label.toLowerCase();
                for (const account of group.accounts) {
                    if (account.id === props.modelValue) {
                        const name = account.bank?.name || 'Account';
                        const number = account.accountNumber ? ' ' + maskAccountNumber(account.accountNumber) : '';
                        return name + number;
                    }
                }
            }
            return 'All accounts';
        });
        function toggleGroup(type) {
            expandedKey.value = expandedKey.value === type ? null : type;
        }
        function selectAccount(key) {
            emit('update:modelValue', key);
            drawerOpen.value = false;
            expandedKey.value = null;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: "account-selector",
                    onClick: _cache[2] || (_cache[2] = ($event) => (openDrawer()))
                }, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "account-label" }, "View", -1)),
                    _createElementVNode("div", _hoisted_1, [
                        (selectedAvatarStack.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedAvatarStack.value.urls, (url, i) => {
                                    return (_openBlock(), _createElementBlock("img", {
                                        key: i,
                                        class: _normalizeClass(["selected-stack-avatar", { 'stack-overlap': i > 0 }]),
                                        src: url,
                                        onError: _cache[0] || (_cache[0] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                    }, null, 42, _hoisted_3));
                                }), 128)),
                                (selectedAvatarStack.value.overflowCount > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, " +" + _toDisplayString(selectedAvatarStack.value.overflowCount), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : (selectedAvatarUrl.value)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "selected-avatar",
                                    src: selectedAvatarUrl.value,
                                    onError: _cache[1] || (_cache[1] = ($event) => ($event.target.src = require('@/assets/round3.png'))),
                                    alt: ""
                                }, null, 40, _hoisted_5))
                                : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(selectedLabel.value), 1)
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "account-triangle" }, "▼", -1))
                ]),
                _createVNode(SlideDrawer, {
                    modelValue: drawerOpen.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((drawerOpen).value = $event)),
                    title: "Spending analysis view"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                            (accountGroups.value.length > 1)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "account-row",
                                    onClick: _cache[3] || (_cache[3] = ($event) => (selectAccount('all')))
                                }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "account-row-label" }, "All accounts", -1)),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(formatBalance(allAccountsBalance.value)), 1),
                                        (_ctx.modelValue === 'all')
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "row-icon tick",
                                                src: require('@/assets/check-tick.svg'),
                                                alt: ""
                                            }, null, 8, _hoisted_10))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountGroups.value, (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: group.type,
                                    class: "account-group"
                                }, [
                                    _createElementVNode("div", {
                                        class: "account-row",
                                        onClick: ($event) => (toggleGroup(group.type))
                                    }, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(group.label), 1),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(formatBalance(group.balance)), 1),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["row-icon triangle", { expanded: expandedKey.value === group.type }])
                                            }, "▼", 2)
                                        ])
                                    ], 8, _hoisted_11),
                                    _createVNode(_Transition, { name: "expand" }, {
                                        default: _withCtx(() => [
                                            (expandedKey.value === group.type)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    (group.accounts.length > 1)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: "sub-account-row",
                                                            onClick: ($event) => (selectAccount(group.type))
                                                        }, [
                                                            _createElementVNode("div", _hoisted_17, [
                                                                _createElementVNode("div", _hoisted_18, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.avatarStack, (url, i) => {
                                                                        return (_openBlock(), _createElementBlock("img", {
                                                                            key: i,
                                                                            class: _normalizeClass(["stack-avatar", { 'stack-overlap': i > 0 }]),
                                                                            src: url,
                                                                            onError: _cache[4] || (_cache[4] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                                                        }, null, 42, _hoisted_19));
                                                                    }), 128)),
                                                                    (group.overflowCount > 0)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, " +" + _toDisplayString(group.overflowCount), 1))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _createElementVNode("span", _hoisted_21, "All " + _toDisplayString(group.label.toLowerCase()), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_22, [
                                                                _createElementVNode("span", _hoisted_23, _toDisplayString(formatBalance(group.balance)), 1),
                                                                (_ctx.modelValue === group.type)
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 0,
                                                                        class: "row-icon tick",
                                                                        src: require('@/assets/check-tick.svg'),
                                                                        alt: ""
                                                                    }, null, 8, _hoisted_24))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ], 8, _hoisted_16))
                                                        : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.accounts, (account) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: account.id,
                                                            class: "sub-account-row",
                                                            onClick: ($event) => (selectAccount(account.id))
                                                        }, [
                                                            _createElementVNode("div", _hoisted_26, [
                                                                _createElementVNode("img", {
                                                                    class: "account-avatar",
                                                                    src: getAvatarUrl(account),
                                                                    onError: _cache[5] || (_cache[5] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                                                }, null, 40, _hoisted_27),
                                                                _createElementVNode("div", _hoisted_28, [
                                                                    _createElementVNode("span", _hoisted_29, _toDisplayString(account.bank?.name || 'Bank'), 1),
                                                                    _createElementVNode("div", _hoisted_30, [
                                                                        _createElementVNode("span", null, _toDisplayString(account.accountType?.prettyName || ''), 1),
                                                                        (account.accountNumber)
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(maskAccountNumber(account.accountNumber)), 1))
                                                                            : _createCommentVNode("", true)
                                                                    ])
                                                                ])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_32, [
                                                                _createElementVNode("span", _hoisted_33, _toDisplayString(formatBalance(account.balance ?? 0)), 1),
                                                                (_ctx.modelValue === account.id)
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 0,
                                                                        class: "row-icon tick",
                                                                        src: require('@/assets/check-tick.svg'),
                                                                        alt: ""
                                                                    }, null, 8, _hoisted_34))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ], 8, _hoisted_25));
                                                    }), 128))
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]));
                            }), 128))
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
